module.exports = __webpack_public_path__ + "img/stag_pertronus.d94bddf8.jpg";